"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _PageSpinner = _interopRequireDefault(require("./PageSpinner.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PageLoader = function PageLoader(_ref) {
  var pastDelay = _ref.pastDelay,
    message = _ref.message,
    error = _ref.error,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  if (error) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-message"
    }, "Sorry, there was a problem loading the page.");
  }
  if (pastDelay) {
    return /*#__PURE__*/_react["default"].createElement(_PageSpinner["default"], {
      className: className,
      "data-testid": dataTestId
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "spinner"
    }), message && /*#__PURE__*/_react["default"].createElement("p", {
      className: "spinner-message"
    }, message));
  }
  return null;
};
PageLoader.defaultProps = {
  className: 'page-spinner',
  error: false,
  /* https://github.com/jamiebuilds/react-loadable#avoiding-flash-of-loading-component */
  pastDelay: true,
  message: '',
  dataTestId: 'page-spinner'
};
PageLoader.propTypes = {
  className: _propTypes.PropTypes.string,
  error: _propTypes.PropTypes.bool,
  pastDelay: _propTypes.PropTypes.bool,
  message: _propTypes.PropTypes.string,
  dataTestId: _propTypes.PropTypes.string
};
PageLoader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PageLoader",
  "props": {
    "className": {
      "defaultValue": {
        "value": "'page-spinner'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "pastDelay": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "message": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "dataTestId": {
      "defaultValue": {
        "value": "'page-spinner'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(PageLoader);
exports["default"] = _default;